import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ControllerSwitchComponent } from './controller-switch.component';

@NgModule({
    declarations: [
        ControllerSwitchComponent
    ],
    exports: [
        ControllerSwitchComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class ControllerSwitchModule { }
